import Paper from "@mui/material/Paper";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "vino/core";
import PaymentMethodCard from "vino/components/cart-checkout/PaymentMethodCard";
import {
	PaymentCardSchema,
	PaymentMethodDefaultValues,
} from "vino/components/cart-checkout/models";
import OrderSummary from "./OrderSummary";
import { createSubscription } from "store/vino/subscriptionSlice";

const Payment = ({ onBack }) => {
	const dispatch = useDispatch();
	const subscription = useSelector(({ vino }) => vino.subscription.entity);
	const user = useSelector(({ auth }) => auth.user);
	const isSubmitting = useSelector(
		({ vino }) => vino.subscription.isSubmitting
	);

	const methods = useForm({
		mode: "onChange",
		defaultValues: { card: PaymentMethodDefaultValues },
		resolver: yupResolver(PaymentCardSchema),
	});

	const { handleSubmit } = methods;

	const onSubmit = (paymentMethod) => {
		const sub = {
			...subscription,
			paymentMethod,
		};
		dispatch(
			createSubscription({
				subscription: sub,
				user,
			})
		);
	};

	return (
		<Paper className="w-full rounded-20 shadow flex flex-wrap">
			<div className="flex-1 w-3/5">
				<FormProvider {...methods}>
					<form
						noValidate
						className="flex flex-col w-full"
						onSubmit={handleSubmit(onSubmit)}
					>
						<div className="flex items-center p-20">
							<Typography className="text-16 font-medium">Payment</Typography>
						</div>
						<div className="w-full px-20">
							<Typography className="text-16">Credit Card</Typography>
							<div className="mt-10">
								<PaymentMethodCard />
							</div>
						</div>
						<Divider className="my-10" />
						<div className="w-full p-20">
							<div className="flex justify-between">
								<Button onClick={onBack}>
									<i className="fa-solid fa-angle-left mr-5"></i> Back
								</Button>
								<Button isSubmitting={isSubmitting} type="submit">
									Place Order
								</Button>
							</div>
						</div>
					</form>
				</FormProvider>
			</div>
			<div className="w-2/5">
				<OrderSummary />
			</div>
		</Paper>
	);
};

export default Payment;
